// TaskBreadcrumbs.jsx: // Page view for editing a single task in detail.
import { Link } from 'react-router-dom';

/**
 * Renders only the root ancestor as a breadcrumb link above a task title.
 * breadcrumb: Array of { id: string, title: string }
 */
const TaskBreadcrumbs = ({ breadcrumb }) => {
  if (!Array.isArray(breadcrumb) || breadcrumb.length === 0) return null;

  const root = breadcrumb[0];

  return (
    <div className="breadcrumb-container">
      <Link
        to={`/app/organize/${root.id}`}
        onClick={(e) => e.stopPropagation()}
      >
        {root.title}
      </Link>
      {breadcrumb.length > 1 ? (
        <span className="breadcrumb-separator"> …</span>
      ) : null}
    </div>
  );
};

export default TaskBreadcrumbs;
